import React, { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import authSideImg from '../../assets/images/authSideImg3.png'
import { getValues } from 'services/storage'
import { handleLogout } from 'utils'

const Auth = (props) => {
    const navigate = useNavigate();

    // console.log({
    //     user_authData: props.user_authData,
    //     user_loggedIn: props.user_loggedIn
    // });
    

    // useEffect(() => {
    //     if (props.user_authData === null) navigate('/auth/login');
    // }, [props.user_authData]);

    return (
        <div className='w-full h-full min-h-[100vh] max-h-[100vh] flex bg-Background5'>
            <div className='flex flex-col w-[56.5%] max-h-[100vh] tablet:w-full desktop:p-20 !p-12 mobile:p-8 items-center justify-center'>
                <div className='w-full min-h-[70vh] tablet:min-h-[100vh] flex justify-center items-center'>
                    <div className='w-80 h-fit'>
                        <Outlet />
                    </div>
                </div>
            </div>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
            <div className='w-[43.5%] tablet:hidden rounded-tl-[20px] overflow-hidden h-[100vh] flex-shrink-0'>
                <img src={authSideImg} alt="auth_sideImg" className="w-full h-full object-cover object-center" />
            </div>
        </div>
    )
}
 
const mapStateToProps = (state: any) => ({
    user_authData: state.auth.user_authData,
    user_loggedIn: state.auth.user_loggedIn,
})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Auth);